import { useCallback, useMemo } from "react";
import useCurrentUser from "hooks/useCurrentUser";
import { isPermitted, isAnyPermitted, hasAdminPermission } from "util/PermissionsMixin";
const usePermissions = () => {
  var _a;
  const currentUser = useCurrentUser();
  const _isPermitted = useCallback(
    (permissions) => isPermitted(currentUser == null ? void 0 : currentUser.permissions, permissions),
    [currentUser == null ? void 0 : currentUser.permissions]
  );
  const _isAnyPermitted = useCallback(
    (permissions) => isAnyPermitted(currentUser == null ? void 0 : currentUser.permissions, permissions),
    [currentUser == null ? void 0 : currentUser.permissions]
  );
  const isAdmin = hasAdminPermission((_a = currentUser == null ? void 0 : currentUser.permissions) != null ? _a : []);
  return useMemo(
    () => ({ isPermitted: _isPermitted, isAnyPermitted: _isAnyPermitted, isAdmin }),
    [_isPermitted, _isAnyPermitted, isAdmin]
  );
};
export default usePermissions;
